import { render, staticRenderFns } from "./TherapyTextQuestion.vue?vue&type=template&id=2f9ccca0&scoped=true"
import script from "./TherapyTextQuestion.vue?vue&type=script&lang=js"
export * from "./TherapyTextQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9ccca0",
  null
  
)

export default component.exports